import { useQuery } from '@apollo/client';
import { graphql } from '@packages/charka-common-ui/graphql/types';

const QUERY = graphql(`
  query PrintRuleList($menuId: String!) {
    getPrintRuleList(menuId: $menuId) {
      id
      title
      menuPrintRules {
        id
        name
      }
    }
  }
`);

export function usePrintRuleList(menuId: string) {
  return useQuery(QUERY, {
    variables: {
      menuId,
    },
  });
}
